import { useContext } from "react";
import {Dialog} from "@mui/material";
import { getBrowserName } from "../utils/utils";
import { LanguageContext } from "../utils/context/languageContext";
import { LanguageKeys } from "../utils/languageKeys";
import { Config } from "../types/interfaces";

function Modal({ message, config, testId }: { message?: string; config?: Config; testId?: string }) {
  const { translate } = useContext(LanguageContext) || {};



  return (
    <Dialog open className="confirm-modal common-ui-main">
      <div data-testid={testId} className="modal-main">
        <div className="text-center">
          {message ? (
            <>
              <h2
                style={{
                  fontFamily:
                    config?.style?.heading?.headingFontFamily ||
                    "SeriouslyNostalgic Fn",
                  fontSize: config?.style?.heading?.headingFontSize || "32px",
                  color: config?.style?.heading?.headingColor || "#000",
                  fontWeight:
                    config?.style?.heading?.headingFontWeight || "normal",
                }}
              >
                {translate?.(LanguageKeys.cameraAlreadyInUse)}
              </h2>
              <p
                className="mt-[0.5rem] text-sm"
                style={{
                  fontFamily:
                    config?.style?.base?.baseFontFamily || "Inter, sans-serif",
                  fontSize: config?.style?.base?.baseFontSize || "16px",
                  color: config?.style?.base?.baseTextColor || "#000",
                }}
              >
                {translate?.(LanguageKeys.tryClosingBrowser)}
              </p>
            </>
          ) : (
            <>
              <h2
                style={{
                  fontFamily:
                    config?.style?.heading?.headingFontFamily ||
                    "SeriouslyNostalgic Fn",
                  fontSize: config?.style?.heading?.headingFontSize || "32px",
                  color: config?.style?.heading?.headingColor || "#000",
                  fontWeight:
                    config?.style?.heading?.headingFontWeight || "normal",
                }}
              >
                {translate?.(LanguageKeys.checkCameraSettings)}
              </h2>
              <p
                className="mt-[0.5rem] text-sm"
                style={{
                  fontFamily:
                    config?.style?.base?.baseFontFamily || "Inter, sans-serif",
                  fontSize: config?.style?.base?.baseFontSize || "16px",
                  color: config?.style?.base?.baseTextColor || "#000",
                }}
              >{`${translate?.(
                LanguageKeys.setting
              )} > ${getBrowserName()} > ${translate?.(
                LanguageKeys.enableCameraPermissions
              )}`}</p>
            </>
          )}
        </div>
      </div>
    </Dialog>
  );
}

export default Modal;
